<template>
  <div data-cy="asset-component-result-month">
    {{months}}
  </div>
</template>

<script>
	import dateConverter from '../../utils/converters/date.converter';
	import DateWithoutTimeAPI from "../../api/DateWithoutTimeAPI";

	export default {
		name: 'MonthCalculatorWidget',
		props: {
			startDate: {
				required: false,
				type: Date,
				default: null
			},
			endDate: {
				required: false,
				type: Date,
				default: null
			},
		},
		data() {
			return {
				startDateAsString: null,
				endDateAsAsString: null,
				months: null,
			}
		},
		watch: {
			startDate() {
				this.calculateAsync();
			},

			endDate() {
				this.calculateAsync();
			},
		},

		methods: {
			async calculateAsync() {
				if (this.startDate == null || this.endDate == null) {
					return;
        	}

				const beginDate = encodeURIComponent(dateConverter.convertToString(this.startDate));
				const endDate = encodeURIComponent(dateConverter.convertToString(this.endDate));

				this.months = await new DateWithoutTimeAPI().calculateMonthsCount(beginDate, endDate);
			}
		}
	};
</script>
<style>

</style>

